import React from 'react'
import PageHeader from '../shared/pageHeader/PageHeader'
import Footer from '../shared/Footer'
import Header from '../shared/header/Header'
import NavigationMenu from '../shared/navigationMenu/NavigationMenu'
import DistrictTable from './DistrictTable'
import DistrictHeader from './DistrictHeader'

const DistrictList = () => {
    return (
        <>

            <Header />
            <NavigationMenu />
            <main className="nxl-container">
                <div className="nxl-content">
                    <PageHeader >
                        <DistrictHeader/>
                        </PageHeader>
                    <div className='main-content'>
                        <div className='row'>
                            <DistrictTable />
                        </div>
                    </div>
            <Footer />
                </div>
            </main>
        </>
    )
}

export default DistrictList